module.exports = __webpack_public_path__ + "media/5_4.a68af2dc.wav";